import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { FlexGrid, PageHeader } from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import Button from 'ui/buttons/Button'
import { TagSmartview } from 'widgets/smartviews/files/TagSmartview'
import { TagCard } from 'ui/cards/TagCard'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { NavigateOnPipe, OnNavigatePipeline } from '@morningtrain/react-navigation'
import { Pipeline } from '@morningtrain/react-pipelines'
import { TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export default function ManageEmployeeFiles () {
  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false}>
      <Translator namespace='files.employee_files'>

        <OnNavigatePipeline>
          <MountSmartviewOnPipe smartview={<TagSmartview/>} replace/>
        </OnNavigatePipeline>

        <PageHeader title={<TranslatedTitle name='titles.manage'/>}>
          <MountSmartviewWithModelOnClick smartview={<TagSmartview/>} replace>
            <Button><Translation name='create_title'/></Button>
          </MountSmartviewWithModelOnClick>
        </PageHeader>

        <Collection resourceName='files.tags'>
          <FlexGrid className='mt-4 mb-12' responsive={{ xl: 3, md: 2 }}>
            <ForEachModel>
              <Pipeline>
                <TriggerPipelineOnClick>
                  <TagCard/>
                </TriggerPipelineOnClick>
                <NavigateOnPipe route='app.files.employee_files.tag' routeParameters={{ file_tag: 'model:id' }}/>
              </Pipeline>
            </ForEachModel>
          </FlexGrid>
        </Collection>
      </Translator>
    </AdminPageWithSmartview>
  )
}
